import { ComponentProps, FunctionComponent, ReactNode } from 'react';
import Button from '../forms/Button';

type Props = {
    cancelButtonText?: string;
    heading: string;
    okButtonText?: string;
    okButtonVariant?: ComponentProps<typeof Button>['variant'];
    onCancel: () => void;
    onSubmit: () => void;
    text: string;
    visible: boolean;
    children?: ReactNode;
};

const OverlayConfirmModal: FunctionComponent<Props> = ({ cancelButtonText = 'Nej', heading, okButtonText = 'Ja', okButtonVariant = 'success', onCancel, onSubmit, text, visible, children }) => {
    if (!visible) {
        return null;
    }

    return (
        <div className="cover">
            <div className="cover__content">
                <div className="cover__heading">{heading}</div>
                <div className="cover__text">{text}</div>
                {children}
                <Button text={cancelButtonText} additionalClassName="btn-lg" variant="secondary" onClick={onCancel} />
                <Button text={okButtonText} additionalClassName={'btn btn-lg'} variant={okButtonVariant} onClick={onSubmit} />
            </div>
        </div>
    );
};

export default OverlayConfirmModal;
